(ns ui.view.card.attachments.sub
  (:require
   [re-frame.core :as rf]
   [clojure.edn :as edn]
   [common.util :as cu]
   [ui.view.card.sub :as common-sub]
   [ui.state.session.model :as session-model]
   [reagent.ratom :as ratom]
   [ui.view.card.attachments.model :as model]))

(rf/reg-sub
 ::primary-entity
 (fn [[_ ctx]]
   [(rf/subscribe [::common-sub/entities ctx])])
 (fn [[entities-by-id] [_ {:keys [entity-id]}]]
   (get entities-by-id entity-id)))

(rf/reg-sub-raw
 ::folder-names
 (fn [db-atom [_ ctx]]
   (ratom/reaction
    (let [primary-entity @(rf/subscribe [::primary-entity ctx])
          primary-entity-type (:entity/type primary-entity)
          containing-entity-id (case primary-entity-type
                                 :entity.type/oppo (:oppo/pipeline primary-entity)
                                 nil)
          containing-entity (when containing-entity-id
                              (session-model/get-entity @db-atom containing-entity-id))
          folders (merge {}
                         (when-let [fs (:common/folder-structure primary-entity)]
                           (cond (map? fs)
                                 fs
                                 (string? fs)
                                 (edn/read-string fs)))
                         (when containing-entity
                           (when-let [fs (:common/folder-structure containing-entity)]
                             (cond (map? fs)
                                   fs
                                   (string? fs)
                                   (edn/read-string fs)))))]
      (->> folders
           keys
           (remove cu/blank-value?)
           (sort-by cu/str-trim-lcase)
           vec)))))

;; TODO: allow more broad attachment display, for example related entities?
(rf/reg-sub
 ::attachments
 (fn [[_ ctx]]
   [(rf/subscribe [::common-sub/entities ctx])])
 (fn [[entities-by-id]
      [_ {:keys [entity-id] :as _ctx}]]
   (let [primary-entity (get entities-by-id entity-id)
         attachments (->> primary-entity
                          :common/attachments
                          (mapv #(get entities-by-id %))
                          (sort-by :attachment/created))]
     attachments)))

(rf/reg-sub
 ::attachments-in-folder
 (fn [[_ ctx]]
   [(rf/subscribe [::attachments ctx])])
 (fn [[attachments]
      [_ _ctx folder-name]]
   (let [folder-name-lc (cu/str-trim-lcase folder-name)]
     (->> attachments
          (filterv (fn [a]
                     (let [in-folder? (= (str "/" folder-name-lc)
                                         (cu/str-trim-lcase (:attachment/folder-path a)))]
                       in-folder?)))))))

(rf/reg-sub
 ::attachments-not-in-folders
 (fn [[_ ctx]]
   [(rf/subscribe [::attachments ctx])
    (rf/subscribe [::folder-names ctx])])
 (fn [[attachments folder-names]]
   (let [folder-names-lc (mapv cu/str-trim-lcase folder-names)]
     (->> attachments
          (filterv (fn [a]
                     (let [folder-path (:attachment/folder-path a)
                           no-folder? (cu/blank-value? folder-path)
                           folder-name (when-not no-folder?
                                         (subs folder-path 1))]
                       (or no-folder?
                           (and folder-name
                                (not (some #{folder-name} folder-names-lc)))))))))))

(rf/reg-sub
 ::uploads-in-progress
 common-sub/card-state-extractor
 (fn [[card-state] [_ _]]
   (->> card-state
        :uploads-in-progress
        vals
        (sort-by :started-at))))

(rf/reg-sub
 ::folder-states
 common-sub/card-state-extractor
 (fn [[card-state]]
   (get-in card-state model/folders-states-path)))

(rf/reg-sub
 ::folder-state
 (fn [[_ ctx _folder-name]]
   [(rf/subscribe [::folder-states ctx])])
 (fn [[folder-states] [_ _ctx folder-name]]
   (get folder-states folder-name)))

(rf/reg-sub
 ::folder-expanded?
 (fn [[_ ctx folder-name]]
   [(rf/subscribe [::folder-state ctx folder-name])])
 (fn [[folder-state]]
   (get-in folder-state model/folder-expanded-path)))
